module.exports = __webpack_public_path__ + "img/38.d3e2df6a.jpg";